import React, { useEffect, useState } from 'react';
import TwWarning from '../../../components/TwWarning/TwWarning';
import { SearchLoadParams } from '../../../redux/api/load/load.model';
import useNotifications from '../../../providers/Notifications/Notifications.provider';
import { TwButtonType } from '../../../components/TwButtons/TwButtons';
import { useDeleteOrderMutation } from '../../../redux/api/orders/ordersApi';
import { useAppSelector } from '../../../redux/hooks';

export interface DeleteLoadProps {
  open: boolean;
  loadNumber?: number | string;
  loadId: string;
  onClose?: () => void;
  searchParams?: SearchLoadParams;
}

const DeleteLoad: React.FC<DeleteLoadProps> = ({
  open,
  loadNumber,
  loadId,
  onClose,
  searchParams
}): JSX.Element => {
  const { addNotification } = useNotifications();

  const [deleteOrder] = useDeleteOrderMutation();

  const [showWarning, setShowWarning] = useState<boolean>(false);

  const tripsFilterParams = useAppSelector((state) => state.activeTrips.filters);

  const handleDelete = async (id: string): Promise<void> => {
    // deleteOrder({ id, searchParams })
    deleteOrder({ id, searchTripParams: { filters: tripsFilterParams } })
      .unwrap()
      .then((response) => {
        let otherExpensesUpdatedMsg = '';

        if (response.data.other_expenses_updated > 0) {
          const moreThanOne = response.data.other_expenses_updated > 1;
          otherExpensesUpdatedMsg = `. ${response.data.other_expenses_updated} other expense${
            moreThanOne ? 's' : ''
          } unlinked from order`;
        }
        const message = response.message
          ? `${response.message}${otherExpensesUpdatedMsg}`
          : 'Order deleted successfully';

        addNotification({
          message,
          variant: 'success'
        });
      })
      .catch((error) => {
        if (error.status === 409) {
          addNotification({
            message: error.data.message || 'Order cannot be deleted',
            variant: 'error'
          });
        }
        console.error(error);
      })
      .finally(() => {
        onClose && onClose();
      });
  };

  const handleClose = (): void => {
    onClose && onClose();
  };

  return (
    <TwWarning
      warningTitle={`Delete order forever?`}
      warningMessage={
        <div>
          {' '}
          Are you sure you want to delete{' '}
          <span style={{ fontWeight: '600' }}>Order {loadNumber}</span>? You can’t undo this action.
        </div>
      }
      open={open}
      handleClose={handleClose}
      showWarning={showWarning}
      setShowWarning={setShowWarning}
      onContinue={(): Promise<void> => handleDelete(loadId)}
      customizedContinue={{ label: 'Delete', type: TwButtonType.negative }}
    />
  );
};

export default DeleteLoad;
